import React from 'react';
import { Helmet } from 'react-helmet-async';

export const SEOHead = ({ 
  title = 'Školobot | AI pro české pedagogy',
  description = 'AI vyvinutá na míru českému školství. 100+ šablon, AI asistenti, inteligentní shrnutí videí a AI detektor. V souladu s RVP 2025. Vyzkoušejte zdarma.',
  path = '/',
  type = 'website',
  schema = null
}) => {
  const baseUrl = 'https://skolobot.cz';
  const fullUrl = `${baseUrl}${path}`;
  const imageUrl = 'https://customer-assets.emergentagent.com/job_9bea0608-78cd-4395-a48b-75a51bf92aaf/artifacts/nwo14gqn_customcolor_logo_transparent_background.png';

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={fullUrl} />
      
      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:site_name" content="Školobot" />
      <meta property="og:locale" content="cs_CZ" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />

      {/* Schema.org JSON-LD */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
};

// Pre-built schemas
export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Školobot",
  "legalName": "THEBIGDOT s.r.o.",
  "url": "https://skolobot.cz",
  "logo": "https://customer-assets.emergentagent.com/job_9bea0608-78cd-4395-a48b-75a51bf92aaf/artifacts/nwo14gqn_customcolor_logo_transparent_background.png",
  "email": "info@skolobot.cz",
  "telephone": "+420583033357",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Zámostní 1155/27",
    "addressLocality": "Ostrava",
    "postalCode": "710 00",
    "addressCountry": "CZ"
  },
  "sameAs": []
};

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Školobot",
  "url": "https://skolobot.cz",
  "description": "AI vyvinutá na míru českému školství a každodenní práci českých pedagogů.",
  "inLanguage": "cs",
  "publisher": {
    "@type": "Organization",
    "name": "THEBIGDOT s.r.o."
  }
};

export const softwareSchema = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  "name": "Školobot",
  "applicationCategory": "EducationalApplication",
  "description": "AI vyvinutá na míru českému školství. 100+ šablon, AI asistenti, generování obrázků a AI detektor. V souladu s RVP 2025. Vyzkoušejte zdarma.",
  "operatingSystem": "Web Browser",
  "offers": [
    {
      "@type": "Offer",
      "name": "Pro jednotlivce",
      "price": "399",
      "priceCurrency": "CZK",
      "billingIncrement": "P1M",
      "description": "Roční licence pro jednotlivé pedagogy. Všechny šablony, AI chat, generování obrázků, překlady, AI detektor."
    },
    {
      "@type": "Offer",
      "name": "Školní licence",
      "price": "299",
      "priceCurrency": "CZK",
      "billingIncrement": "P1M",
      "description": "Roční licence pro školy. Vše z individuálního plánu + neomezený počet pedagogů, sdílená knihovna, prioritní podpora."
    }
  ],
  "provider": {
    "@type": "Organization",
    "name": "THEBIGDOT s.r.o.",
    "url": "https://skolobot.cz"
  },
  "audience": {
    "@type": "EducationalAudience",
    "educationalRole": "teacher"
  },
  "inLanguage": "cs",
  "availableLanguage": "cs"
};

export const createFAQSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map(faq => ({
    "@type": "Question",
    "name": faq.q,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.a
    }
  }))
});

export const createBreadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": `https://skolobot.cz${item.path}`
  }))
});

export default SEOHead;
